import React from "react";
import Question from "../Global/Question";

const BusinessType = (props) => {
  return <Question {...props} />;
};

export default BusinessType;
